exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3qkxG7xQgobltL9G4Qj3Qd{display:flex;margin:30px auto;max-width:500px}._3qkxG7xQgobltL9G4Qj3Qd div{margin:0 20px}._3qkxG7xQgobltL9G4Qj3Qd video{max-height:300px;max-width:169.01408px;box-shadow:2px 2px 4px rgba(0,0,0,0.1)}\n", ""]);

// Exports
exports.locals = {
	"Step4": "_3qkxG7xQgobltL9G4Qj3Qd"
};